import React, { useEffect, useState } from 'react';

// import Scss
import './assets/scss/themes.scss';

// imoprt Route
import Route from './Routes';
import { toast, ToastContainer } from 'react-toastify';
// Import Toastify CSS
import 'react-toastify/dist/ReactToastify.css';
import { useNavigate, Navigate } from 'react-router-dom';
import {
    AuthenticationAPI,
    AuthenticationLegacyAPI,
    CarePlanContentJsonAPI,
    GetCommonListAPI,
    GetMemberInfoAPI,
    LanguagesJsonAPI
} from './helpers/APIS/CommonApisSchema';
import { SelectFullStateOfThisAPI } from './Store/callAPI/selectors';
import { useSelector } from 'react-redux';
import { DataKey } from './Store/callAPI/allAPIs';
import { callAPIAction, removeAPIDataAction } from './Store/callAPI/actions';
import { getURLParamas } from './pages/Authentication/authenticationUtils';
import { ShowErrMsg } from './Components/Hooks/UserHooks';
import { SelectSearchValInStore } from './Store/commonStore/selectors';
import { getMemberInfoAPIURL } from './helpers/CustomApiUrls/CommonApiUrl';

function App() {
    const navigate = useNavigate();
    const [hasRedirected, setHasRedirected] = useState(false);

    const AuthenticationAPIData = useSelector((state) => SelectFullStateOfThisAPI(state, AuthenticationAPI));
    const AuthenticationLegacyAPIData = useSelector((state) => SelectFullStateOfThisAPI(state, AuthenticationLegacyAPI));
    const GetMemberInfoAPIData = useSelector((state) => SelectFullStateOfThisAPI(state, GetMemberInfoAPI));

    const linkParams = useSelector((state) => SelectSearchValInStore(state, 'linkParams'));

    useEffect(() => {
        if (
            window.location.pathname.startsWith('/authorize') ||
            window.location.pathname.startsWith('/tufts') ||
            window.location.pathname.startsWith('/uhc') ||
            window.location.pathname.startsWith('/iehp') ||
            window.location.pathname.startsWith('/aetna') ||
            window.location.pathname.startsWith('/uchwa') ||
            window.location.pathname.startsWith('/hpsj')
        ) {
            getURLParamas(Navigate);
            setHasRedirected(false);
        }
    }, [navigate]);

    useEffect(() => {
        if (AuthenticationAPIData?.[DataKey]?.isSuccess) {
            if (AuthenticationAPIData?.[DataKey]?.errorMessage?.length > 0) {
                toast.error(AuthenticationAPIData?.[DataKey]?.errorMessage[0]);
                removeAPIDataAction('AuthenticationAPI');
            } else {
                callAPIAction(LanguagesJsonAPI);
                callAPIAction(CarePlanContentJsonAPI);
                if (process.env.REACT_APP_CUSTOM_TENANT === 'ggh') {
                    navigate('/careplan');
                } else {
                    callAPIAction(GetCommonListAPI);
                    callAPIAction(GetMemberInfoAPI, getMemberInfoAPIURL(AuthenticationAPIData?.[DataKey]?.data?.referralId));
                }
            }
        } else {
            ShowErrMsg(AuthenticationAPIData, 'AuthenticationAPI');
        }
    }, [AuthenticationAPIData, navigate]);

    useEffect(() => {
        if (AuthenticationLegacyAPIData?.[DataKey]?.isSuccess) {
            if (AuthenticationLegacyAPIData?.[DataKey]?.errorMessage?.length > 0)
                toast.error(AuthenticationLegacyAPIData?.[DataKey]?.errorMessage[0]);
            else {
                callAPIAction(LanguagesJsonAPI);
                callAPIAction(CarePlanContentJsonAPI);
                navigate('/careplan');
            }

            removeAPIDataAction('AuthenticationLegacyAPI');
        } else {
            ShowErrMsg(AuthenticationLegacyAPIData, 'AuthenticationLegacyAPI');
        }
    }, [AuthenticationLegacyAPIData, navigate]);

    // SETTING THE MEASURES FROM THE MEMBER INFO API
    useEffect(() => {
        if (GetMemberInfoAPIData?.[DataKey]?.isSuccess && !hasRedirected) {
            setHasRedirected(true);
            const assessments = GetMemberInfoAPIData?.[DataKey]?.data?.assessments;

            const assessmentMatch =
                linkParams?.pageName === 'assessments'
                    ? assessments?.find((i) => String(i?.assessmentPlanId) === String(linkParams?.modeId))
                    : assessments?.find((i) => String(i?.assessmentPlanId) === String(linkParams?.pageName));

            if (assessmentMatch) {
                navigate('/assessments', {
                    state: {
                        assessmentData: assessmentMatch
                    }
                });
            } else {
                navigate('/careplan');
            }
        }
    }, [GetMemberInfoAPIData, linkParams, navigate, hasRedirected]);

    return (
        <React.Fragment>
            <ToastContainer
                theme="colored"
                position="top-right"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss={false}
                draggable={false}
                pauseOnHover={true}
                limit={0}
            />
            <Route />
        </React.Fragment>
    );
}

export default App;
